export default class AbstractForm {
    inited = false;
    isLoading = false;
    blocks = {};

    /**
     * Инициализируем поведение
     *
     * @param {jquery} element
     */
    init(element) {
        if (this.inited) {
            return;
        }

        this.inited = true;
        this.element = element;

        Object.keys(this.blocks).forEach((key) => {
            const block = this.blocks[key];

            block.init(this.element);
            block.syncShowState();
        });

        this.element.removeClass('loading');
    }

    addBlock(key, block) {
        if (!key || !block) {
            return this;
        }

        if (this.blocks[key]) {
            console.warn(`Rewirte ${key} block`);
        }

        this.blocks[key] = block;
        return this;
    }

    /**
     * Отобразить блок по его имени
     *
     * @param {String} name
     *
     * @return {AbstractForm} this
     */
    showBlock(name) {
        if (!this.inited) {
            return this;
        }

        Object.keys(this.blocks).forEach((key) => {
            const block = this.blocks[key];

            if (key === name) {
                block.show();
            } else {
                block.hide();
            }
        });

        return this;
    }
}
